/**
 * Animation constants partagées (Framer Motion).
 * Centraliser les objets évite les re-renders inutiles et standardise les transitions.
 */

// État initial : invisible, légèrement décalé vers le bas
export const FADE_IN_UP_HIDDEN = { opacity: 0, y: 30 };
export const FADE_IN_UP_HIDDEN_SHORT = { opacity: 0, y: 20 };

// État visible final : opaque, position naturelle
export const FADE_IN_VISIBLE = { opacity: 1, y: 0 };

// Pour les images : effet de scale subtil
export const SCALE_HIDDEN = { opacity: 0, scale: 0.96 };
export const SCALE_VISIBLE = { opacity: 1, scale: 1 };

// Animations basiques (opacité seule)
export const OPACITY_HIDDEN = { opacity: 0 };
export const OPACITY_VISIBLE = { opacity: 1 };

// Configurations communes pour Intersection Observer
export const VIEWPORT_ONCE = { once: true };
export const VIEWPORT_ONCE_MARGIN = { once: true, margin: "-100px" };

// Transitions communes
export const TRANSITION_SLOW = { duration: 0.8 };
export const TRANSITION_MEDIUM = { duration: 0.7 };
export const TRANSITION_FAST = { duration: 0.6 };
